const AUTH_TOKEN_KEY = 'emporion_admin_auth_token'

const canUseSessionStorage = (): boolean => typeof window !== 'undefined' && typeof window.sessionStorage !== 'undefined'

const readPersistedToken = (): string | null => {
  if (!canUseSessionStorage()) return null
  try {
    const value = window.sessionStorage.getItem(AUTH_TOKEN_KEY)
    return value && value.trim() ? value.trim() : null
  } catch {
    return null
  }
}

const writePersistedToken = (token: string | null): void => {
  if (!canUseSessionStorage()) return
  try {
    if (token && token.trim()) {
      window.sessionStorage.setItem(AUTH_TOKEN_KEY, token.trim())
      return
    }
    window.sessionStorage.removeItem(AUTH_TOKEN_KEY)
  } catch {
    // best-effort persistence only
  }
}

let runtimeAuthToken: string | null = readPersistedToken()

export const getAuthToken = (): string | null => {
  if (runtimeAuthToken) return runtimeAuthToken
  runtimeAuthToken = readPersistedToken()
  return runtimeAuthToken
}

export const setAuthToken = (token: string): void => {
  runtimeAuthToken = token.trim()
  writePersistedToken(runtimeAuthToken)
}

export const clearAuthToken = (): void => {
  runtimeAuthToken = null
  writePersistedToken(null)
}

export const getAuthHeaders = (): Record<string, string> => {
  const token = getAuthToken()
  return token ? { Authorization: `Bearer ${token}` } : {}
}
